import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import Login from './Login';
import { postLoginRequest } from '../../redux/actions/authentication';

function mapStateToProps(state) {
  return {
    authentication: state.authentication
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators({ postLoginRequest }, dispatch)
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
